import { render, staticRenderFns } from "./ModalListSKP.vue?vue&type=template&id=255710ac&scoped=true&lang=html&"
import script from "./ModalListSKP.vue?vue&type=script&lang=js&"
export * from "./ModalListSKP.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "255710ac",
  null
  
)

export default component.exports